<div class="header-utility-bar">
  <div class="wrap header-utility">
    @if (tenantScope.tenant(); as tenant) {
      <a class="logo" [routerLink]="['/retailer', tenant.slug]" [attr.aria-label]="tenant.name + ' home'">
        <b>{{ tenant.theme.logoPrimaryText }}</b>
        <span>{{ tenant.theme.logoSecondaryText }}</span>
      </a>
    } @else {
      <a class="logo" routerLink="/" aria-label="Brijj Finds home">
        <b>brijj</b>
        <span>finds</span>
      </a>
    }

    <app-category-subnav />

    @if (!tenantScope.tenant()) {
      <nav class="header-utility-nav" aria-label="Marketplace shortcuts">
        <button
          type="button"
          class="utility-item location-btn"
          [attr.aria-label]="locationAriaLabel()"
          (click)="openLocationDialog()"
        >
          <app-icon name="map-pin" [size]="15" />
          <span class="location-text">
            @if (shopperLocation.chosenLocation(); as chosen) {
              <span class="location-prefix">Deliver to</span>
              <strong>{{ chosen.label }}</strong>
            } @else {
              <strong>Set location</strong>
            }
          </span>
        </button>
        <span class="utility-divider" aria-hidden="true"></span>
        <a class="utility-item" routerLink="/why-brijj">Why Brijj</a>
        <a class="utility-item utility-item--accent" routerLink="/sell" aria-label="Become a Seller">
          <span class="utility-label-full" aria-hidden="true">Become a Seller</span>
          <span class="utility-label-short" aria-hidden="true">Sell</span>
        </a>
      </nav>
    }
  </div>
</div>

<div class="wrap header-commerce">
  <form class="header-search" role="search" (ngSubmit)="onSearchSubmit()">
    <mat-form-field appearance="outline" subscriptSizing="dynamic">
      <button matIconPrefix type="submit" class="search-submit" aria-label="Search">
        <app-icon name="search" [size]="18" />
      </button>
      <input
        matInput
        type="search"
        [formControl]="searchControl"
        [placeholder]="searchPlaceholder()"
        [matAutocomplete]="auto"
        aria-label="Search listings"
      />
      <mat-autocomplete #auto="matAutocomplete" (optionSelected)="onSuggestionSelected($event)">
        @for (suggestion of suggestions(); track suggestion.label) {
          <mat-option [value]="suggestion.label">
            <span class="suggestion-row">
              {{ suggestion.label }}
              @if (suggestion.categorySlug !== null) {
                <span class="suggestion-hint">Category</span>
              }
            </span>
          </mat-option>
        }
        @if (noMatchQuery(); as query) {
          <mat-option class="suggestion-empty" [value]="query">
            No matches for "{{ query }}" - press Enter to search everything
          </mat-option>
        }
      </mat-autocomplete>
    </mat-form-field>
  </form>

  <div class="header-actions">
    <a class="cart-btn" routerLink="/cart" [attr.aria-label]="cartAriaLabel()">
      <span class="cart-btn__icon">
        <app-icon name="cart" [size]="20" />
        @if (cart.lineCount() > 0) {
          <span class="count-badge" aria-hidden="true">{{ cart.lineCount() }}</span>
        }
      </span>
      <span class="cart-btn__label" aria-hidden="true">Cart</span>
    </a>

    @if (session.isSignedIn()) {
      <button
        type="button"
        class="account-btn"
        [matMenuTriggerFor]="accountMenu"
        [attr.aria-label]="accountAriaLabel()"
      >
        <span class="avatar" aria-hidden="true">{{ avatarInitial() }}</span>
        <span class="account-btn__name" aria-hidden="true">{{ session.shopper()?.firstName }}</span>
        <app-icon class="account-btn__caret" name="chevron-down" [size]="14" aria-hidden="true" />
      </button>
      <mat-menu #accountMenu="matMenu" class="account-menu">
        @if (session.shopper(); as account) {
          <div class="account-menu__who">
            <span class="account-menu__avatar" aria-hidden="true">{{ avatarInitial() }}</span>
            <span class="account-menu__id">
              <b>{{ account.displayName }}</b>
              <span>{{ account.email }}</span>
            </span>
          </div>
        }
        <a mat-menu-item routerLink="/account/orders">
          <app-icon class="menu-icon" name="package" [size]="16" aria-hidden="true" />
          <span>Orders</span>
        </a>
        <a mat-menu-item routerLink="/account/auctions">
          <app-icon class="menu-icon" name="gavel" [size]="16" aria-hidden="true" />
          <span>Auctions</span>
        </a>
        <a mat-menu-item routerLink="/account/favorites">
          <app-icon class="menu-icon" name="heart" [size]="16" aria-hidden="true" />
          <span>Favorites</span>
        </a>
        <mat-divider />
        <a mat-menu-item routerLink="/account/profile">
          <app-icon class="menu-icon" name="user" [size]="16" aria-hidden="true" />
          <span>Profile</span>
        </a>
        <a mat-menu-item routerLink="/account/settings">
          <app-icon class="menu-icon" name="settings" [size]="16" aria-hidden="true" />
          <span>Settings</span>
        </a>
        <mat-divider />
        <button mat-menu-item type="button" class="account-menu__signout" (click)="signOut()">
          <app-icon class="menu-icon" name="log-out" [size]="16" aria-hidden="true" />
          <span>Sign Out</span>
        </button>
      </mat-menu>
    } @else {
      <a mat-button class="sign-in-btn" routerLink="/sign-in" [queryParams]="{ returnUrl: returnUrl() }">Sign In</a>
    }
  </div>
</div>
